"use client";
import { DatePicker } from "@/components/datePicker";
import { HeaderProps } from "./header.types";
import { Button } from "@/components/ui/button";
import clsx from "clsx";
import { FC } from "react";

const Header: FC<HeaderProps> = ({
  title,
  subtitle,
  className,
  actions,
  datePicker = true,
}) => {
  const titleAlign = typeof title === "object" ? title.align : "center";
  const titleValue = typeof title === "object" ? title.value : title;
  const TitleIcon = typeof title === "object" ? title.icon : undefined;

  return (
    <header className={clsx("page-header", className)}>
      {datePicker && <DatePicker />}
      <div
        className={clsx("flex flex-col text-center space-y-sm ", {
          "ml-auto": titleAlign === "center",
          "text-right w-full": titleAlign === "right",
        })}
      >
        <span className="flex flex-row items-center space-x-sm">
          {TitleIcon && <TitleIcon className={"text-foreground/50"} />}
          <h1 className="prose-heading-18-bold text-surface/70 ml-auto leading-[16px] ">
            {titleValue}
          </h1>
        </span>
        {subtitle && (
          <p className="prose-caption-12-semibold text-secondary-200 leading-[12px] ">
            {subtitle}
          </p>
        )}
        {/*<Statistics />*/}
      </div>

      {actions &&
        actions.map((action, index) => {
          const IconComponent = action.icon;
          const DialogComponent = action.dialog;
          return DialogComponent ? (
            <DialogComponent
              key={index}
              trigger={
                <Button
                  onClick={action.onClick}
                  className={"ml-auto space-x-sm"}
                  variant={"outline"}
                >
                  <IconComponent />
                  <p className="prose-paragraph-14-semibold">{action.text}</p>
                </Button>
              }
            />
          ) : (
            <Button
              onClick={action.onClick}
              key={index}
              className={"ml-auto space-x-sm"}
              variant={"outline"}
            >
              <IconComponent />
              <p className="prose-paragraph-14-semibold">{action.text}</p>
            </Button>
          );
        })}
    </header>
  );
};

export { Header };
